import React from "react";
import IconMap from "./IconMap";
import '../../styles/filemanager.scss'

export default class FolderItem extends React.Component {
    constructor(props) {
        super(props)
        this.state =
        {
            // showContextMenu: false,
            // favorite: false
        }
        this.inputRef = React.createRef();
        // this.folderRef = React.createRef()
    }

    clickTimeOut = null;
    // onDoubleClickHandler = () => {
    //     if (this.clickTimeOut !== null) {
    //         clearTimeout(this.clickTimeOut)
    //         this.props.onClick()
    //         this.clickTimeOut = null;
    //         return;
    //     }
    //     this.clickTimeOut = setTimeout(() => {
    //         clearTimeout(this.clickTimeOut)
    //         this.clickTimeOut = null;
    //     }, 200);
    // };

    componentDidUpdate() {
        if (this.props.rename) {
            document.addEventListener('keypress', this.onKeyPress)
        }
    }

    onKeyPress = (event) => {
        if (event.key === "Enter") {
            document.removeEventListener('keypress', this.onKeyPress);
            const newName = this.inputRef.current.value;
            this.props.onRenameItem(newName)
        }
    }

    componentDidMount() {
        this.clickTimeOut = null
    }

    _handleFolderName() {
        return (
            this.props.rename
                ? <input contentEditable={true} className="folderNameInput renameInput py-1 br-5" autoFocus={true} ref={this.inputRef} defaultValue={this.props?.name} />
                : (
                    <div className="flexcc w-100 no_selection" style={{ disply: 'flex', justifyContent: 'center' }}>
                        {this.props.view === 'details' &&
                            <p className="font-size-13 px-1 w-100" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingLeft: '5px' }}>{this.props?.name}</p>
                        }
                        {this.props.view === 'mediumIcons' &&
                            <p className="font-size-13 px-1 w-100 flexcc" style={{ width: '69px', whiteSpace: 'pre-wrap', wordBreak: 'break-all', paddingBottom: '1px', textAlign: 'center' }}>{this.props?.name.length > 19 ? this.props?.name?.substr(0, 19) + '...' : this.props?.name}</p>
                        }
                    </div>
                )
        )
    }

    render() {
        if (this.props.view === 'details') {
            return (
                <div className='w-100 folderItem'>
                    <div className="w-100 d-flex" style={{ alignItems: 'center' }} >
                        <div className="d-flex prd-2">
                            <img src={IconMap["folder"]} draggable={false} alt="" style={{}} />
                        </div>
                        <div className="flexcc" style={{ display: 'flex', justifyContent: 'left', width: 'calc(100% - 41px)' }}>
                            {this._handleFolderName()}
                        </div>
                    </div>
                </div>
            )
        }
        else if (this.props.view === 'mediumIcons') {
            return (
                <div className='w-100 folderItemGridView' style={{ height: '80px' }}>
                    <div className=" d-flex" style={{ flexDirection: 'column', alignItems: 'center', borderRadius: '5px' }}>
                        <div className="flexcc" style={{ width: '45px', height: '45px' }}>
                            <img src={IconMap["folder"]} draggable={false} alt="" style={{ width: '40px', marginTop: '5px', }} />
                        </div>
                        <div style={{ disply: 'flex', justifyContent: 'center', height: '40px' }}>
                            {this._handleFolderName()}
                        </div>
                    </div>
                </div>
            )
        }
    }
}